import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { useAnalytics } from "@/contexts/AnalyticsContext";

type PageViewData = {
  event: "PAGE_VIEW";
  pageName: string;
  referrer: string;
};

const PageViewTracker = () => {
  const location = useLocation();
  const { logEvent } = useAnalytics();
  const previousPathname = useRef<string | null>(null);

  useEffect(() => {
    if (previousPathname.current === location.pathname) {
      return;
    }

    const pageViewData: PageViewData = {
      event: "PAGE_VIEW",
      pageName: location.pathname,
      referrer: previousPathname.current || "",
    };

    try {
      logEvent(pageViewData);
    } catch (error) {
      console.warn("Failed to track page view:", error);
    }

    previousPathname.current = location.pathname;
  }, [location.pathname, location.search, logEvent]);

  return null;
};

export default PageViewTracker;
